export default __webpack_public_path__ + "static/media/logo.2665fea9.svg";